document.addEventListener('DOMContentLoaded', () => {
  const closeBtn = document.querySelector('.manu-close-btn');
  const closeicon = document.querySelector('.icon-close');
  const drawer = document.getElementById('details-menu-drawer-container');

  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () {
      // Drawer close karo
      if (drawer.tagName.toLowerCase() === 'details') {
        // drawer.removeAttribute('open');
        closeicon.click();
        console.log(document.body);
      } else {
        drawer.classList.remove('open'); // Agar class use ho rahi ho
        drawer.style.display = 'none';   // Optional
        document.body.style.overflowY = 'scroll !important';
      }

      // Body ka scroll enable karo
      document.body.style.overflowY = 'scroll !important';
      document.documentElement.style.overflowY = 'scroll !important';

      // Agar class lagayi ho thi to remove karo
      console.log(document.body);
    });
  }
});